import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Component to protect routes that require authentication
export const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  
  // Show a loading indicator while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Render child routes if authenticated
  return <Outlet />;
};

// Component to protect routes that require specific role
export const RoleBasedRoute = ({ requiredRole }) => {
  const { user, hasRole, loading } = useAuth();
  
  // Show a loading indicator while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Redirect to unauthorized page if user doesn't have required role
  if (!hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Render child routes if authorized
  return <Outlet />;
};

// Component for admin-only routes
export const AdminRoute = () => {
  return <RoleBasedRoute requiredRole="admin" />;
};

// Component for expert-only routes
export const ExpertRoute = () => {
  return <RoleBasedRoute requiredRole="expert" />;
};

export const SuperExpertRoute = () => {
  return <RoleBasedRoute requiredRole="super_expert" />;
};

// Component for user-only routes
export const UserRoute = () => {
  return <RoleBasedRoute requiredRole="user" />;
};